// extracted by mini-css-extract-plugin
module.exports = {"brandLight":"#00f2d0","brandDark":"#008da0"};